var SpriteSymbol = require("../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "play",
  "use": "play-usage",
  "viewBox": "0 0 68 68",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 68 68\" id=\"play\"><path fill=\"#F2F2F2\" fill-rule=\"evenodd\" d=\"M34 68C15.222 68 0 52.778 0 34S15.222 0 34 0s34 15.222 34 34-15.222 34-34 34m-8-48v28l24-14.304z\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol